import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SalesCatalystTargetMarketInput from '../SalesCatalystTargetMarket/SalesCatalystTargetMarketInput';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import SalesCatalystBoxInput from '../../common/SalesCatalystBoxInput';
import SalesCatalystInput from '../../common/SalesCatalystInput';
import { getBackGroundColor, getTextColor } from '../../../util/SalesCatalystUtils';
import {
  SALES_CATALYST_COMPETITION,
} from '../../../constants';

class SalesCatalystCompetitionInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      editSubCategory: '',
      editDefaultHeader: '',
      editIndex: 0,
    };
  }

  deleteHandler = (field, subCategory, index) => {
    this.props.deleteSalasCatalystSelection(field, subCategory,
      SALES_CATALYST_COMPETITION, index);
  }

  toggleEditMode = (editSubCategory, editIndex, editDefaultHeader, editMode) => {
    this.setState({
      editSubCategory,
      editIndex,
      editMode,
      editDefaultHeader,
    });
  }

  renderOneCompetitor=(dataSelection, dataOnScreen) => {
    return (
      <SalesCatalystTargetMarketInput
        className={'large-4 medium-4 small-4 columns'}
        hideOverlapBox
        color={this.props.color}
      >
        <div className="large-4 medium-4 small-4 columns">
          <SalesCatalystBoxInput
            color={this.props.color}
            defaultHeader={'COMPETITOR 1/3'}
            data={dataSelection.competitor[0]}
            deleteHandler={this.deleteHandler}
            subCategory={'competitor'}
            field={'dataSelection'}
            index={0}
            backgroundColor={getBackGroundColor(dataSelection.competitor[0],
              dataOnScreen.competition, 'COMPETITORS1', this.props.color)}
            color={getTextColor(dataSelection.competitor[0],
              dataOnScreen.competition)}
            dataOnScreen={dataOnScreen.competition}
            toggleEditMode={this.toggleEditMode}
            renderEditView={this.state.editMode}
           // color={this.props.color}
          />
        </div>
      </SalesCatalystTargetMarketInput>
    );
  }

  renderTwoCompetitor = (dataSelection, dataOnScreen) => {
    return (
      <SalesCatalystTargetMarketInput
        className={'large-3 medium-3 small-3 columns'}
        hideOverlapBox
        color={this.props.color}
      >
        <div className="large-3 medium-3 small-3 columns">
          <SalesCatalystBoxInput
            defaultHeader={'COMPETITOR 1/3'}
            data={dataSelection.competitor[0]}
            deleteHandler={this.deleteHandler}
            subCategory={'competitor'}
            field={'dataSelection'}
            index={0}
            backgroundColor={getBackGroundColor(dataSelection.competitor[0],
              dataOnScreen.competition, 'COMPETITORS1', this.props.color)}
            color={getTextColor(dataSelection.competitor[0],
              dataOnScreen.competition)}
            dataOnScreen={dataOnScreen.competition}
            toggleEditMode={this.toggleEditMode}
            renderEditView={this.state.editMode}
          />
        </div>
        <div className="large-3 medium-3 small-3 columns">
          <SalesCatalystBoxInput
            defaultHeader={'COMPETITOR 2/3'}
            data={dataSelection.competitor[1]}
            deleteHandler={this.deleteHandler}
            subCategory={'competitor'}
            field={'dataSelection'}
            index={1}
            backgroundColor={getBackGroundColor(dataSelection.competitor[1],
              dataOnScreen.competition, 'COMPETITORS2', this.props.color)}
            color={getTextColor(dataSelection.competitor[1],
              dataOnScreen.competition)}
            dataOnScreen={dataOnScreen.competition}
            toggleEditMode={this.toggleEditMode}
            renderEditView={this.state.editMode}
          />
        </div>
      </SalesCatalystTargetMarketInput>
    );
  }

  renderThreeCompetitor = (dataSelection, dataOnScreen) => {
    return (
      <SalesCatalystTargetMarketInput
        className={'large-2 medium-2 small-2 columns col-half-offset'}
        hideOverlapBox
        color={this.props.color}
      >
        <div className="large-2 medium-2 small-2 columns col-half-offset">
          <SalesCatalystBoxInput
            defaultHeader={'COMPETITOR 1/3'}
            data={dataSelection.competitor[0]}
            deleteHandler={this.deleteHandler}
            subCategory={'competitor'}
            field={'dataSelection'}
            index={0}
            backgroundColor={getBackGroundColor(dataSelection.competitor[0],
              dataOnScreen.competition, 'COMPETITORS1', this.props.color)}
            color={getTextColor(dataSelection.competitor[0],
              dataOnScreen.competition)}
            dataOnScreen={dataOnScreen.competition}
            toggleEditMode={this.toggleEditMode}
            renderEditView={this.state.editMode}
          />
        </div>
        <div className="large-2 medium-2 small-2 columns col-half-offset">
          <SalesCatalystBoxInput
            defaultHeader={'COMPETITOR 2/3'}
            data={dataSelection.competitor[1]}
            deleteHandler={this.deleteHandler}
            subCategory={'competitor'}
            field={'dataSelection'}
            index={1}
            backgroundColor={getBackGroundColor(dataSelection.competitor[1],
              dataOnScreen.competition, 'COMPETITORS2', this.props.color)}
            color={getTextColor(dataSelection.competitor[1],
              dataOnScreen.competition)}
            dataOnScreen={dataOnScreen.competition}
            toggleEditMode={this.toggleEditMode}
            renderEditView={this.state.editMode}
          />
        </div>
        <div
          className="large-4 medium-4 small-4 columns col-half-offset"
          style={{ float: 'left' }}
        >
          <SalesCatalystBoxInput
            defaultHeader={'COMPETITOR 3/3'}
            data={dataSelection.competitor[2]}
            deleteHandler={this.deleteHandler}
            subCategory={'competitor'}
            field={'dataSelection'}
            index={2}
            backgroundColor={getBackGroundColor(dataSelection.competitor[2],
              dataOnScreen.competition, 'COMPETITORS3', this.props.color)}
            color={getTextColor(dataSelection.competitor[2],
              dataOnScreen.competition)}
            dataOnScreen={dataOnScreen.competition}
            toggleEditMode={this.toggleEditMode}
            renderEditView={this.state.editMode}
          />
        </div>
      </SalesCatalystTargetMarketInput>
    );
  }

  render() {
    const { dataSelection, dataOnScreen } = this.props;
    return (
      <div>
        {(dataSelection.competitor.length === 0 && !this.state.editMode) &&
          this.renderOneCompetitor(dataSelection, dataOnScreen)
        }
        {(dataSelection.competitor.length === 1 && !this.state.editMode) &&
          this.renderTwoCompetitor(dataSelection, dataOnScreen)
        }
        {(dataSelection.competitor.length >= 2 && !this.state.editMode) &&
          this.renderThreeCompetitor(dataSelection, dataOnScreen)
        }
        {(this.state.editMode) &&
          <div>
            <div className="large-12 medium-12 small-12 columns" style={{ paddingTop: '1%' }}>
              <div className="large-3 medium-3 small-3 columns" style={{ width: '21%' }}>
                <span className="target-market-label">{this.state.editDefaultHeader}:</span>
              </div>
              <div className="large-6 medium-6 small-6 columns target-market-input">
                <SalesCatalystInput
                  data={dataSelection[this.state.editSubCategory].length > 0
                    ? dataSelection[this.state.editSubCategory][this.state.editIndex] : []}
                  subCategory={this.state.editSubCategory}
                  field={'dataSelection'}
                  index={this.state.editIndex}
                  targetLabelClass={'target-label-field'}
                  dataList={dataSelection[this.state.editSubCategory].length > 0
                    ? dataSelection[this.state.editSubCategory] : []}
                  toggleEditMode={this.toggleEditMode}
                  renderEditView={this.state.editMode}
                />
              </div>
            </div>
          </div>}
      </div>
      );
  }
}

SalesCatalystCompetitionInput.propTypes = {
  dataSelection: PropTypes.shape({}),
  deleteSalasCatalystSelection: PropTypes.func,
  dataOnScreen: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
        typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
    dataSelection: state.salesCatalyst.dataSelection,
    dataOnScreen: state.salesCatalyst.dataOnScreen,
    salesCatalystStudy: state.study.salesCatalystStudy,
  };
}


const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const deleteSalasCatalystSelection = (mainCategory, subCategory, section, index) => {
    dispatch(salesCatalystActions.deleteSalesCatalystSelection(mainCategory,
      subCategory, section, index));
    dispatch(salesCatalystActions.resetGraphData(subCategory));
  };

  return Object.assign({}, stateProps, ownProps, {
    deleteSalasCatalystSelection,
  });
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystCompetitionInput);
